import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser/src/browser';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
  ],
  declarations: []
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts